import React from 'react';

export const GoBack = () => {
  return (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.8337 9.83337H3.00024M3.00024 9.83337L8.83358 15.6667M3.00024 9.83337L8.83358 4.00004" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
  );
}
